module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAHZJREFUOBFjYBgFpIbA////dUGYWH0sxCoEqguGqr1MjB4mYhSRo4ZmBhPlGGDYNgAxDDQQpYlYRUBTQYaTbihQ0y2YkyigbxHr0EGsbsCCAmgxeZGHLzChhsLilPSUQYThRBtKs5xHM4NJKd3W4guqUTmcIQAAvETJ5iToCTAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_HeightMin_normal.png
// module id = 313
// module chunks = 0